import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { saveStep3Callback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { pageState, wizardSteps } from 'Pages/Workflow/recoil/state/page'
import { step3State } from 'Pages/Workflow/recoil/state/step3'
import { step3Valid } from 'Pages/Workflow/validation/validation'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'

const Footer = () => {
  const intl = useIntl()
  const history = useHistory()

  const { Draft } = useRecoilValue(workflowDetails)
  const { Step } = useRecoilValue(step3State)

  const setWizardStep = useSetRecoilState(wizardSteps)
  const saveStep3 = useRecoilCallback(saveStep3Callback, [])
  const [{ edit, saveAndExit }, setPageState] = useRecoilState(pageState)

  const handleBack = () => {
    setWizardStep((prev) => ({ ...prev, wizardStep: 2 }))
  }

  const exit = () => {
    setPageState((prev) => ({
      ...prev,
      isDirty: false,
      saveAndExit: true
    }))
  }

  useEffect(() => {
    saveAndExit &&
      history.push(`/automation/workflows/list?saved=1&edit=${edit ? 1 : 0}`)
  }, [saveAndExit])

  const handleSaveExit = () => {
    saveStep3({ onSuccess: exit })
  }

  return (
    <Flex alignItems='center' justifyContent='space-between' columnGap='8px'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        data-mu-test='back'
        onClick={handleBack}
      >
        {intl.formatMessage({ id: 'Load.AutomationWorkflow.PrevStepButton' })}
      </Button>

      <FlexItem>
        <Flex justifyContent='flex-end' columnGap='8px'>
          {Draft && (
            <Button
              kind={BUTTON_VARIANT_SECONDARY}
              data-mu-test='save-exit'
              onClick={handleSaveExit}
              disabled={!step3Valid(Step)}
            >
              {intl.formatMessage({ id: 'Load.AutomationWorkflow.Draft' })}
            </Button>
          )}
          <FlexItem>
            <Button
              kind={BUTTON_VARIANT_PRIMARY}
              data-mu-test='next'
              onClick={saveStep3}
              disabled={!step3Valid(Step)}
            >
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.NextStepButton'
              })}
            </Button>
          </FlexItem>
        </Flex>
      </FlexItem>
    </Flex>
  )
}

export default Footer
